import { forwardRef, type Ref, type SVGProps } from "react";
const IconMoreVerticalOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      d="M18 16a2 2 0 1 1-4 0 2 2 0 0 1 4 0m2 0a4 4 0 1 0-8 0 4 4 0 0 0 8 0M18 6a2 2 0 1 1-4 0 2 2 0 0 1 4 0m2 0a4 4 0 1 0-8 0 4 4 0 0 0 8 0m-2 20a2 2 0 1 1-4 0 2 2 0 0 1 4 0m2 0a4 4 0 1 0-8 0 4 4 0 0 0 8 0"
    />
  </svg>
);
const ForwardRef = forwardRef(IconMoreVerticalOutlineSVG);
ForwardRef.displayName = "IconMoreVerticalOutline";
export { ForwardRef as IconMoreVerticalOutline };
